// extracted by mini-css-extract-plugin
module.exports = {"financeFaq":"index_financeFaq__wE65W","financeFaqP":"index_financeFaqP___45g0"};